<template>
  <div>
    <!-- 标准回复 -->
    <PageAllow controller="QacenterStandardRequests" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                v-model="options.key_word"
                @text="KeyWord = $event"
                :label="$t('QacenterStandardRequests.search')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click.stop="Add = true"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("QacenterStandardRequests.add") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="standard_requests"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    Edit = true;
                    editId = item.id;
                    editCode = item.code;
                    editTitle = item.title;
                    editContext = item.context;
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("QacenterStandardRequests.actions.edit") }}
                </v-btn>
              </template>
              <span>{{ $t("QacenterStandardRequests.actions.edit") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    delDialog = true;
                    delId = item.id;
                  "
                >
                  <!-- <v-icon x-small class="pe-1"></v-icon> -->
                  {{ $t("QacenterStandardRequests.actions.delete") }}
                </v-btn>
              </template>
              <span>{{ $t("QacenterStandardRequests.actions.delete") }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <v-dialog v-model="Add" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("QacenterStandardRequests.detail") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Add = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 subtitle-1">
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="2" class="font-weight-bold text-right">
                {{ $t("QacenterStandardRequests.code")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="10">
                <ValidationProvider rules="required">
                  <v-text-field
                    v-model="addCode"
                    single-line
                    dense
                    hide-details
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2" class="font-weight-bold text-right">
                {{ $t("QacenterStandardRequests.title")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="10">
                <ValidationProvider rules="required">
                  <v-text-field
                    v-model="addTitle"
                    single-line
                    dense
                    hide-details
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2" class="font-weight-bold text-right">
                {{
                  $t("QacenterStandardRequests.context") + $t("Global.colon")
                }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="10">
                <ValidationProvider rules="required">
                  <v-textarea v-model="addContext" outlined auto-grow />
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Add = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="AddConfirm()">
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="Edit" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("QacenterStandardRequests.detail") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Edit = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("QacenterStandardRequests.code")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <ValidationProvider rules="required">
                  <v-text-field
                    v-model="editCode"
                    single-line
                    dense
                    hide-details
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("QacenterStandardRequests.title")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <ValidationProvider rules="required">
                  <v-text-field
                    v-model="editTitle"
                    single-line
                    dense
                    hide-details
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("QacenterStandardRequests.context") + $t("Global.colon")
                }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="9">
                <ValidationProvider rules="required">
                  <v-textarea v-model="editContext" outlined auto-grow />
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Edit = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="EditConfirm()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="delDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 text-center subtitle-1">
          {{ $t("QacenterStandardRequests.del_text") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="delDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="accent" depressed @click="Delete()">
            {{ $t("$vuetify.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Reauest from "@/api/standard_requests.js";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const defaultOptions = {};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    Add: false,
    Edit: false,
    delDialog: false,
    standard_requests: [],
    itemEditData: {},
    key_word: "",
    addCode: "",
    addTitle: "",
    addContext: "",

    editId: "",
    editCode: "",
    editTitle: "",
    editContext: "",

    delId: null,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.customerMaintenance"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Nav.complaint"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Nav.standard_request"),
        disabled: true,
        href: "/qacenter/standard-requests",
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("QacenterStandardRequests.Fields.code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: i18n.t("QacenterStandardRequests.Fields.title"),
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: i18n.t("QacenterStandardRequests.Fields.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("QacenterStandardRequests.Fields.created_user"),
          align: "start",
          sortable: false,
          value: "creater_name",
        },
        {
          text: i18n.t("QacenterStandardRequests.Fields.frequency"),
          align: "start",
          sortable: false,
          value: "frequency",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    ...mapState(["loading"]),
  },
  mounted() {
    // this.getStandardRequestFromAPI();
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        key_word: this.KeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getStandardRequestFromAPI() {
      Reauest.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.standard_requests = response.data.qacenter_standard_requests;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },

    AddConfirm() {
      var data = [];
      data.push({
        code: this.addCode,
        title: this.addTitle,
        context: this.addContext,
      });
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Reauest.add(data[0]).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.getStandardRequestFromAPI();
                }
                this.Add = false;
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },

    EditConfirm() {
      var data = [];
      data.push({
        id: this.editId,
        code: this.editCode,
        title: this.editTitle,
        context: this.editContext,
      });
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Reauest.edit(data[0]).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.getStandardRequestFromAPI();
                }
                this.Edit = false;
              }.bind(this)
            );
          }
        }.bind(this)
      );
      Reauest.edit(data[0]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getStandardRequestFromAPI();
          }
          this.Edit = false;
        }.bind(this)
      );
    },

    Delete() {
      Reauest.del(this.delId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getStandardRequestFromAPI();
          }
          this.delDialog = false;
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStandardRequestFromAPI();
      },
    },
  },
};
</script>

<style>
</style>